// extracted by mini-css-extract-plugin
export default {"VisoGames":"VisoGames_VisoGames__8KSNr","Logo":"VisoGames_Logo__QFptu","Info":"VisoGames_Info__Qg1PL","Light":"VisoGames_Light__7jE-6"};